import Dashboard from '../charts/Dashboard'
import usePageTitle from '../../../util/usePageTitle'

const OverallStatsPage = () => {
  usePageTitle('Overall Stats')
  return <Dashboard />
}

export default OverallStatsPage
